// @flow
import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import "@fortawesome/fontawesome-free/js/all.js";
import "@fortawesome/fontawesome-free/css/all.css";
import "../application/initializers/index";

window.jQuery = $;

require('jquery-ujs');
require('bootstrap');
require('cocoon-rails');

require('../admin/behavior/index');
require('../admin/modules/index');

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
const context = (require: any).context("../admin/controllers", true, /\.js$/)
application.load(definitionsFromContext(context))
